import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import { Button } from 'react-bootstrap';
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../store/allApi";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);
  const [game_amount, setGame_amt] = useState();
  const [gameData, setGameData] = useState({});
  const MyData = localStorage.getItem('meData')
  const meedata = JSON.parse(MyData)
  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);
  const [runningsGames, setRunningsGames] = useState([]);


  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
    //  sendMessage()
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
    // status_fun()
  };

  /// user details end

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2]
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3]
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      // if (Game_Ammount >= 100 && Game_Ammount <= 50000) {

      try {
        const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type }, headers)
        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title:
              "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {
            //  history.push("/login")
          }, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
      }
    }
    //    else {
    //     setIsloading(false);
    //     Swal.fire({
    //       title: "Please Amount should be greater 100 and less 50000!",
    //       icon: "warning",
    //       confirmButtonText: "OK",
    //     });
    //   }
    // } else if (game_type == "ludoClassicRich") {
    //   if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
    //     axios
    //       .post(
    //         baseUrl + `challange/create`,
    //         {
    //           Game_Ammount,
    //           Game_type: game_type,
    //         },
    //         { headers }
    //       )
    //       .then((res) => {
    //         setGame_amt(res?.data?.data?.Game_Ammount);

    //         if (res.data.status == false) {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: res.data.msg,
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (res.data.msg === "you have already enrolled") {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: "You have already enrolled",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (res.data.msg === "You can set maximum 2 battle.") {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: "You can set maximum 2 battle.",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (res.data.msg === "Insufficient balance") {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: "Insufficient balance",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (
    //           res.data.msg ===
    //           "Game amount should be Greater then 50 and less then 50000"
    //         ) {
    //           setIsloading(false);
    //           Swal.fire({
    //             title:
    //               "Game amount should be Greater then 50 and less then 50000",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (res.data.msg === "Set Battle in denomination of 50") {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: "Set Battle in denomination of 50",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else if (res.data.msg === "Technical Issue, Try after an hour!") {
    //           setIsloading(false);
    //           Swal.fire({
    //             title: "Technical Issue, Try after an hour!",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         } else {
    //           setIsloading(false);
    //         }
    //       })
    //       .catch((e) => {
    //         setIsloading(false);
    //         if (e?.response?.status == 401) {
    //           localStorage.removeItem("token");
    //           localStorage.removeItem("token");
    //           window.location.reload();
    //           setTimeout(() => {
    //             //  history.push("/login")
    //           }, 500);
    //         }
    //         if (e?.response?.status == 400 || e?.response?.status == 429) {
    //           Swal.fire({
    //             title: "Please refresh!",
    //             icon: "warning",
    //             confirmButtonText: "OK",
    //           });
    //         }
    //         console.log(e);
    //       });
    //   } else {
    //     setIsloading(false);
    //     Swal.fire({
    //       title: "Please Amount should be greater 550 and less 200000!",
    //       icon: "warning",
    //       confirmButtonText: "OK",
    //     });
    //   }
    // }
    else {
      try {
        const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type }, headers)
        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title:
              "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {
            //  history.push("/login")
          }, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
      }
    }
  };

  //open bat

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
      io.on("gameCreate", (data) => {
        if (
          data?.Accepetd_By?._id === userId ||
          data?.Created_by?._id === userId
        ) {
          if (!MyopenBattle.some((item) => item._id === data._id)) {
            setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
          }
        } else {
          if (!OtheropenBattle.some((item) => item._id === data._id)) {
            setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
          }
        }
      });
      io.on("deletebat", (data) => {
        // Log the _id values in the MyopenBattle array
        setMyOpenBattle((MyopenBattle) => {
          const updatedMyOpenBattle = MyopenBattle.filter(
            (item) => item._id !== data,
          );
          return updatedMyOpenBattle;
        });
        setOtherMyOpenBattle((OtheropenBattle) => {
          const updatedOtheropenBattle = OtheropenBattle.filter(
            (item) => item._id !== data,
          );
          return updatedOtheropenBattle;
        });
      });
  
      io.on("gameUpdate", (data) => {
        setMyOpenBattle((MyopenBattle) => {
          const updatedMyOpenBattle = MyopenBattle.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedMyOpenBattle;
        });
        setOtherMyOpenBattle((OtheropenBattle) => {
          const updatedOtheropenBattle = OtheropenBattle.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedOtheropenBattle;
        });
        if (
          data?.Accepetd_By?._id === userId ||
          data?.Created_by?._id === userId
        ) {
          if (!MyopenBattle.some((item) => item._id === data._id)) {
            setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
          }
        } else {
          if (!OtheropenBattle.some((item) => item._id === data._id)) {
            setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
          }
        }
      });
  
      io.on("startAccepted", (data) => {
        setMyOpenBattle((MyopenBattle) => {
          const updatedMyOpenBattle = MyopenBattle.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedMyOpenBattle;
        });
        setOtherMyOpenBattle((OtheropenBattle) => {
          const updatedOtheropenBattle = OtheropenBattle.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedOtheropenBattle;
        });
  
        if (data.Status === "running" && data?.Created_by?._id === userId) {
          if (!MyrunningBattle.some((item) => item._id === data._id)) {
            setMyRunningBattle((MyrunningBattle) => [...MyrunningBattle, data]);
          }
        } else if (
          data.Status === "running" &&
          data?.Accepetd_By?._id === userId
        ) {
          if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
            setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
          }
        } else {
          if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
            setOtherRunningBattle((OtherrunningBattle) => [
              data,
              ...OtherrunningBattle,
            ]);
          }
        }
      });
  
      io.on("acceptor_seen_game", (data) => {
        // debugger
        setMyOpenBattle((MyopenBattle) => {
          const updatedMyOpenBattle = MyopenBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedMyOpenBattle;
        });
        setOtherMyOpenBattle((OtheropenBattle) => {
          const updatedOtheropenBattle = OtheropenBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedOtheropenBattle;
        });
  
        if (
          data?.Accepetd_By?._id === userId ||
          data?.Created_by?._id === userId
        ) {
          if (!MyrunningBattle.some((item) => item._id === data._id)) {
            setMyRunningBattle((MyrunningBattle) => [...MyrunningBattle, data]);
          }
        }
      });
      io.on("challangeAccept", (data) => {
        setMyOpenBattle((MyopenBattle) => {
          const updatedMyOpenBattle = MyopenBattle?.filter(
            (item) => item._id !== data._id,
          );
          return updatedMyOpenBattle;
        });
        setOtherMyOpenBattle((OtheropenBattle) => {
          const updatedOtheropenBattle = OtheropenBattle?.filter(
            (item) => item._id !== data._id,
          );
          return updatedOtheropenBattle;
        });
  
        if (
          data?.Accepetd_By?._id === userId ||
          data?.Created_by?._id === userId
        ) {
          if (!MyrunningBattle.some((item) => item._id === data._id)) {
            setMyRunningBattle((MyrunningBattle) => [...MyrunningBattle, data]);
          }
        }
      });
    }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    // {console.log(addCaseSetting?.commissionRange2)}
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  const splitRunningBattles = (battleList = []) => {
    const myBattles = [];
    const otherBattles = [];

    battleList.forEach((ele) => {
      if (!ele?.Created_by || !ele?.Accepetd_By) return;

      const isUserBattle =
        ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId;

      if (isUserBattle) {
        myBattles.push(ele);
      } else {
        otherBattles.push(ele);
      }
    });

    return { myBattles, otherBattles };
  };

  useEffect(() => {
    // walletUpdate();
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);

    setOtherRunningBattle(remainingRunning);
    // walletUpdate();
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          return updatedrunningGames;
        });
      } else {
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  
  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      setTimeout(() => { }, 500);
    }

    return () => {
      // role();
    };
  }, []);

  const RunningGames = async () => {
    const access_tokena = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    // axios
    //   .get(baseUrl + `challange/running/all`, { headers })
    try {
      const res = await apiRequest(`challange/running/all`, "GET", null, headers)
      console.log(res)
      // setRunGames(res.data)
      let owenedRunning = [];
      let remainingRunning = [];
      res?.data?.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (
            ele.Created_by?._id == userId ||
            ele.Accepetd_By?._id == userId
          ) {
            owenedRunning.push(ele);
          } else {
            remainingRunning.push(ele);
          }
      });
      setMyRunningBattle(owenedRunning);
      setOtherRunningBattle(remainingRunning);

    } catch (e) {
      console.log("errror", e);
    }
  };

 

  //accept Challange

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/accept/${id}`, "PUT", { Acceptor_by_Creator_at: Date.now() }, headers)
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => { }, 500);
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //reject Game
  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`challange/reject/${id}`, "PUT", { Status: "new" }, headers)
      if (res) {
        // io.emit("gameRejected");
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //delete
  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/delete/${_id}`, "DELETE", null, headers)
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  ///challange/running/update/

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/running/update/${_id}`, "PUT", { Acceptor_seen: true, }, headers)
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
        // io.emit("game_seen");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")




        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      console.log(e);
    }
  };

  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(`challange/requested/running/${game_type}/` + Id, "PATCH", null, headers)
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "Ludo Popular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest("challange/requested/running/" + Id, "PATCH", null, headers)
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };
  // Socket for GameModeChange list

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };
  useEffect(() => {
    RunningGames()
     if (meedata?.verified === "unverified") {
      history.replace("/Profile");
    }
  }, [])

  // language 
  const translations = {
    hi: {
      gameadd: 'गेम बनाये !',
      gameset: 'लगाये',
      openGame: 'खुला गेम ',
      challange: 'चुनोती देने वाला  ',
      entry: 'प्रवेश शुल्क',
      prize: 'इनाम',
      play: 'खेले ',
      running: 'चल रहे गेम ',
      start: 'चालू',
      cancel: 'रद्द करें',
    },
    en: {
      gameadd: 'Create a Battle!',
      gameset: 'Set',
      openGame: 'Open Battles',
      challange: 'Running Battles',
      entry: 'Entry Fee',
      prize: 'Prize',
      play: 'Play',
      running: 'Running Battles',
      start: 'Start',
      cancel: 'Reject',
    },
  };

  const { language } = useContext(LanguageContext);


  // change theme 
  // change theme
  // const theme1 = localStorage.getItem("theme");
  // let theme = "";
  // if (theme1 == "dark") {
  //   theme = "light";
  // } else {
  //   theme = "dark";
  // }
  const theme = localStorage.getItem("theme")
  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : '#fff',
    color: '#fff',
  };
  const styles1 = {
    backgroundColor: 'transparent',
    color: '#fff',
  };
  const styles3 = {
    backgroundColor: theme === 'light' ? '' : '#fff',
    color: theme === 'light' ? 'white' : '#fff',
  };

  const backgroundColor = theme === 'light' ? '#fff' : '#333 !important';
  const battleCardThemes = ["purple", "blue", "green", "gold"];

  const renderOpenBattleCard = (allgame, index) => {
    const themeName = battleCardThemes[index % battleCardThemes.length];
    const isOwnBattle = userId === allgame?.Created_by?._id;
    const gameAmount = allgame?.Game_Ammount;
    const prizeAmount = winnAmount(gameAmount);
    const avatarSrc =  "/images/avatars/Avatar1.png";

    return (
      <div
        key={allgame._id}
        className={`${css.battleCardNeo} ${css[`battleCardNeo_${themeName}`]}`}
      >
        <div className={css.battleMainArea}>
          <div className={css.battleAvatarWrap}>
            <img src={avatarSrc} alt="avatar" className={css.battleAvatar} />
          </div>

          <div className={css.battlePlayerInfo}>
            <div className={css.battleTopline}>
              <span className={css.battleLiveBadge}>OPEN</span>
              {/* <span className={css.battleLabel}>{translations[language].challange}</span> */}
              <div className={css.battleName}>{allgame?.Created_by?.Name || "Player"}</div>
            </div>
            
            <div className={css.battleStats}>
              <div className={css.battleStatItem}>
                <span>{translations[language].entry}</span>
                <strong>₹ {gameAmount}   </strong>
               
              </div>              
              <div className={css.battleStatItem}>
                <span>{translations[language].prize}</span>
                <strong><img
                    src={process.env.PUBLIC_URL + "/images/icons/cup.png"}
                    alt="" width="15" 
                  /> {prizeAmount}</strong>
              </div>
            </div>
          </div>
        </div>

        <div className={css.battleActionArea}>
          {userId !== allgame?.Created_by?._id && allgame?.Status == "new" ? (
            <button
              className={css.battlePlayButton}
              disabled={disable_play}
              onClick={() => {
                disable_play_btn();
                AcceptChallang(allgame?._id);
              }}
            >
              {translations[language].play}
              <span aria-hidden="true">&gt;</span>
            </button>
          ) : isOwnBattle && allgame?.Status == "new" ? (
            
            <button
              className={`${css.battlePlayButton} ${css.battleDeleteButton}`}
              onClick={() => deleteChallenge(allgame?._id)}
              aria-label="Delete battle"
            >
              <MdOutlineDelete />
            </button>
          ) : null}

          {userId !== allgame?.Created_by?._id &&
                  allgame?.Status == "requested" && (
                    <div className={css.battleRequestActions}>
                      <div
                        className={css.battleRequestedBadge}
                      >
                        requested
                      </div>
                      <button
                        className={css.battleRejectButton}
                        onClick={() => RejectGame(allgame?._id)}
                      >
                        cancel
                      </button>
                    </div>
                  )}
                {userId !== allgame?.Created_by?._id &&
                  allgame?.Status == "running" && (
                    <div className="">
                      <audio src={playSound} autoPlay></audio>

                      <Link>
                        <button
                          disabled={disable}
                          className={css.battleStartButton}
                          onClick={(e) => {
                            disablebtn();
                            updateChallenge(allgame?._id);
                            history.push(`/viewgame1/${allgame?._id}`, {
                              prevPath: window.location.pathname,
                            });
                          }}
                        >
                          {translations[language].start}
                        </button>
                      </Link>
                    </div>
                  )}
                  {userId == allgame?.Created_by?._id &&
                    allgame?.Status == "requested" && (
                      <div className={css.battleOwnerActions}>
                        <Link style={{ bottom: "0" }}>
                          <button
                            className={css.battleStartButton}
                            disabled={disable}
                            style={{
                              display: disable ? "none" : "block",
                            }}
                            onClick={(e) => {
                              disablebtn(allgame?._id);
                              req_chall_fun(allgame?._id);
                              // getPost(allgame?._id);
                              // sendMessage()
                              // history.push(`/viewgame1/${allgame?._id}`, {  prevPath: window.location.pathname })
                            }}
                          >
                            {translations[language].start}
                          </button>
                          <button
                            className={
                              disable
                                ? "btn btn-primary d-block"
                                : "btn btn-primary d-none"
                            }
                          >
                            Wait
                          </button>
                        </Link>
                        <button
                          className={disable ? "d-none" : css.battleRejectButton}
                          onClick={() => RejectGame(allgame?._id)}
                          style={{ bottom: "0" }}
                        >
                          {translations[language].cancel}
                        </button>
                      </div>
                    )}
              </div>
            </div>
          );
        };
  return (
    <>
      <Header user={users} />
      <div
        className="leftContainer mb_space "
        style={styles}
      >
        <div className={`Orher_page_main_section ${css.battlePage}`} style={styles}>
          {/* {game_type === "ludoClassicManual" ||
          game_type === "ludoClassicRich" ? (
            <div className="modeButton">
              <Link
                to="ludoClassicManual"
                className={`game_tabs_btn mb-3  ${
                  game_type === "ludoClassicManual" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicManual");
                  GameModeChange();
                }}
              >
                Lite Mode (50 - 500)
              </Link>
              <Link
                to="ludoClassicRich"
                className={`game_tabs_btn mb-3 ml-2 ${
                  game_type === "ludoClassicRich" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicRich");
                  GameModeChange();
                }}
              >
                 Rich Mode (550 - 200000)
              </Link>
            </div>
          ) : (
            ""
          )} */}

          {
            (JSON.parse(localStorage.getItem('sitSetting'))?.ludoClassicAutoMsg != null &&
              JSON.parse(localStorage.getItem('sitSetting'))?.ludoClassicAutoMsg != '') && (
               <div className={css.withdrawBanner}>
              <span className={css.withdrawBolt}>!</span>
              <span> {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.ludoClassicAutoMsg}</span>
              <span className={css.withdrawIcons}></span>
            </div>
            )
          }

          <div className={css.battleShell}>
           

            {/* Create a Battle */}
            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch ==
              true ? (
              <>
                <div className={css.createBattleHeader}>
                  <span>{translations[language].gameadd}</span>
                  <NavLink to="/Rules" className={css.rulesLink}>
                    Rules <span>i</span>
                  </NavLink>
                </div>

                <div className={`${css.createBattleBox} mt-2`}>
                  {addCaseSetting.gameSearch && game_type2 != "new" ? (
                    <div className={css.amountFieldWrap}>
                      <span className={css.amountIcon}>Rs</span>
                      <input
                        className={css.amountInput}
                        type="tel"
                        placeholder="Enter amount"
                        value={Game_Ammount}
                        onChange={(e) => setGame_Ammount(e.target.value)}
                      />
                    </div>
                  ) : null}

                  <div className={css.setButtonWrap}>
                    {" "}
                    {!isLoading ? (
                      <>
                        {addCaseSetting.gameSearch && game_type2 != "new" ? (
                          <button
                            className={css.setBattleButton}

                            onClick={(e) => {
                                e.preventDefault();
                                setGame_Ammount("");
                                ChallengeCreate();
                              }}
                          >
                            {translations[language].gameset}
                          </button>
                        ) : null}
                      </>
                    ) : (
                      <button
                        className={css.setBattleButton}
                        disabled
                      >
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Loading...
                      </button>
                    )}
                  </div>
                </div>
              </>
            ) : (
              ""
            )}


            <div className={css.openBattlesSection}>
              <div className={css.openBattlesHeader}>
                <div className={css.openBattlesIcon}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/Homepage/battleIcon.png"}
                    alt=""
                  />
                </div>
                <div>
                  <div className={css.openBattlesTitle}>{translations[language].openGame}</div>
                  <div className={css.openBattlesSubtitle}>JOIN & WIN EXCITING PRIZES</div>
                </div>
                <span className={css.openBattlesChevron}>&gt;</span>
              </div>

              {MyopenBattle &&
                MyopenBattle
                  .filter((allgame) => allgame.Game_type === game_type)
                  .map((allgame, index) => renderOpenBattleCard(allgame, index))}

              {OtheropenBattle &&
                OtheropenBattle?.filter(
                  (allgame) => allgame.Game_type === game_type
                ).map((allgame, index) => renderOpenBattleCard(
                  allgame,
                  index + (MyopenBattle?.filter((game) => game.Game_type === game_type)?.length || 0)
                ))}
            </div>
            <div className="battle_divider"></div>
            <div className="mb-6" style={{ marginBottom: "70px" }}>
              <div className={css.runningHeader}>
                <div className={css.openBattlesIcon}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/Homepage/battleIcon.png"}
                    alt=""
                  />
                </div>
                <span>{translations[language].challange}</span>

                {/* <button
                  onClick={RunningGames}
                  style={{
                    backgroundColor: "transparent",
                    color: "#1b6ef3",
                    borderRadius: "4px",
                    padding: "4px 2px",
                    fontSize: "12px",
                    border: "none",
                  }}
                >
                  {/* <FiRefreshCcw style={{ margin: "5px" }} /> 
                </button> */}
              </div>

              {MyrunningBattle &&
                MyrunningBattle.map((runnig) => {
                  if (
                    ((userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                        userId == runnig.Accepetd_By._id &&
                        runnig.Acceptor_seen == true) ||
                      runnig.Status === "pending"
                      : (runnig.Status === "running" &&
                        userId == runnig.Created_by._id) ||
                      runnig.Status === "pending") ||
                      runnig.Status == "conflict") &&
                    (runnig.Game_type == game_type ||
                      runnig.Game_type == "ludoClassicManual" ||
                      runnig.Game_type == "ludoClassicRich")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}

              {OtherrunningBattle &&
                OtherrunningBattle.map((runnig) => {
                  if (
                    (userId == runnig.Accepetd_By._id ||
                      userId == runnig.Created_by._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                          userId == runnig.Accepetd_By._id &&
                          runnig.Acceptor_seen == true) ||
                        (runnig.Status === "pending" &&
                          runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                          user == runnig.Created_by._id) ||
                        (runnig.Status === "pending" &&
                          runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                      runnig.Status === "pending") &&
                    (runnig.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <>
                        <RunningCard
                          key={runnig._id}
                          runnig={runnig}
                          user={users}
                          winnAmount={winnAmount}
                        />
                      </>
                    );
                })}

                {/* --------------------- bots -------------  */}
                
                              {runningsGames &&
                                runningsGames.map((runnig) => {
                                  if (
                                    (userId == runnig?.Accepetd_By?._id ||
                                    userId == runnig?.Created_by?._id
                                      ? userId == runnig.Accepetd_By._id
                                        ? (runnig.Status === "running" &&
                                            userId == runnig.Accepetd_By._id &&
                                            runnig.Acceptor_seen == true) ||
                                          (runnig.Status === "pending" &&
                                            runnig.Acceptor_status == null)
                                        : (runnig.Status === "running" &&
                                            user == runnig.Created_by._id) ||
                                          (runnig.Status === "pending" &&
                                            runnig.Creator_Status == null)
                                      : runnig.Status === "running" ||
                                        runnig.Status === "pending") &&
                                    (runnig.Game_type == game_type ||
                                      game_type == "ludoClassicManual" ||
                                      game_type == "ludoClassicRich")
                                  )
                                    return (
                                      <>
                                        <RunningCard
                                          key={runnig._id}
                                          runnig={runnig}
                                          user={users}
                                          winnAmount={winnAmount}
                                        />
                                      </>
                                    );
                                })}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}


